import { MetadataAvatarTypeProperty } from "../../utils/types";
import {
    StoreMetadataBatchAction,
    ClearMetadataCacheAction,
    SetMetadataLoadingAction,
    STORE_METADATA_BATCH,
    CLEAR_METADATA_CACHE,
    SET_METADATA_LOADING
} from "../actions/metadata";

export interface MetadataState {
    cache: {
        [metadataAvatarType: string]: {
            [propertyName: string]: MetadataAvatarTypeProperty;
        };
    };
    loading: {
        [metadataAvatarType: string]: boolean;
    };
}

const initialState: MetadataState = {
    cache: {},
    loading: {}
};

const metadataReducer = (
    state: MetadataState = initialState,
    action: StoreMetadataBatchAction | ClearMetadataCacheAction | SetMetadataLoadingAction
): MetadataState => {
    switch (action.type) {
        case STORE_METADATA_BATCH: {
            const { metadataAvatarType, properties } = action.payload;
            const typeKey = String(metadataAvatarType);
            
            // Create a map of properties by name for easy lookup
            const propertiesMap: { [propertyName: string]: MetadataAvatarTypeProperty } = {};
            properties.forEach(prop => {
                if (prop.name) {
                    propertiesMap[prop.name] = prop;
                }
            });

            return {
                ...state,
                cache: {
                    ...state.cache,
                    [typeKey]: {
                        ...state.cache[typeKey],
                        ...propertiesMap
                    }
                },
                loading: {
                    ...state.loading,
                    [typeKey]: false
                }
            };
        }

        case CLEAR_METADATA_CACHE: {
            const { metadataAvatarType } = action.payload || {};
            
            if (metadataAvatarType) {
                const typeKey = String(metadataAvatarType);
                const newCache = { ...state.cache };
                const newLoading = { ...state.loading };
                
                delete newCache[typeKey];
                delete newLoading[typeKey];
                
                return {
                    ...state,
                    cache: newCache,
                    loading: newLoading
                };
            }
            
            // Clear all cache
            return {
                cache: {},
                loading: {}
            };
        }

        case SET_METADATA_LOADING: {
            const { metadataAvatarType, loading } = action.payload;
            const typeKey = String(metadataAvatarType);
            
            return {
                ...state,
                loading: {
                    ...state.loading,
                    [typeKey]: loading
                }
            };
        }

        default:
            return state;
    }
};

export default metadataReducer;
